import { render } from "./IapPlaceOrderButton.vue?vue&type=template&id=6949e24e&scoped=true"
import script from "./IapPlaceOrderButton.vue?vue&type=script&lang=js"
export * from "./IapPlaceOrderButton.vue?vue&type=script&lang=js"

import "./IapPlaceOrderButton.vue?vue&type=style&index=0&id=6949e24e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6949e24e"]])

export default __exports__